export default "__VITE_ASSET__CnErnT7r__"